import { Link, useLocation } from "react-router-dom";

// ─────────────────────────────────────────────────────────────
// FIXED from the original: the previous version used `text-navy-600`,
// which isn't a real Tailwind color (no "navy" in the default palette)
// — meaning the active-tab highlight was silently doing nothing in
// production. It also used `text-gray-500` instead of the slate scale
// used by every other component in the app.
//
// This version uses real theme tokens, adds a filled-icon + small
// active dot for the current tab (matching the PalmPay reference's
// bottom nav), and is fully theme-aware.
//
// CURVE PASS: rounded top corners + shadow-elevated replace the flat
// border-t — a straight horizontal line doesn't read correctly across
// a curved top edge, so separation now comes entirely from the lift
// shadow (consistent with how cards already separate via fill-step +
// shadow rather than visible borders in dark mode). Added a small dot
// under the active label, matching the PalmPay/Bitget "you are here"
// convention without competing with the icon highlight.
//
// NAV ITEMS UPDATED — Wallet and Bills removed, Business added.
// Now: Home, Business, Reward, Me (4 items instead of 5).
//
// "Profile" relabeled to "Me" per request — only the LABEL changed,
// the path (/profile) and icon (ri-user-line/fill) are untouched,
// since this is a copy change, not a navigation change.
//
// Business points to /business, NOT /business/landing — matches the
// flow already established: CompanyDashboardPage itself handles the
// zero-company redirect to /business/landing internally, so the nav
// button doesn't need its own branching logic for new-vs-returning
// users. One destination, the destination decides what the user sees.
//
// WALLET/BILLS REMOVAL — these routes still exist and are still
// reachable (presumably via Home's own quick-actions or another
// entry point), just no longer one tap away from anywhere in the app.
// Worth confirming that's the intended tradeoff for a fintech app
// where wallet/bills access is likely a frequent action — flagging
// rather than silently assuming it doesn't matter, since I can't see
// what (if anything) replaces that one-tap access elsewhere.
//
// 4-ITEM SPACING — justify-around redistributes evenly regardless of
// item count, so dropping from 5 to 4 items doesn't require any
// layout math changes; each item just gets slightly more horizontal
// breathing room than before.
// ─────────────────────────────────────────────────────────────

const navItems = [
  { label: "Home",     icon: "ri-home-5-line",    activeIcon: "ri-home-5-fill",    path: "/home" },
  { label: "Business", icon: "ri-building-line",  activeIcon: "ri-building-fill",  path: "/business" },
  { label: "Reward",   icon: "ri-gift-line",      activeIcon: "ri-gift-fill",      path: "/rewards" },
  { label: "Me",       icon: "ri-user-line",      activeIcon: "ri-user-fill",      path: "/profile" },
];

export default function MobileBottomNav() {
  const location    = useLocation();
  const currentPath = location.pathname;

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-nav-bg z-50 backdrop-blur-md rounded-t-[28px]" style={{ boxShadow: "var(--shadow-nav)" }}>
      <div className="flex items-center justify-around px-4 pt-2 pb-2 max-w-md mx-auto">
        {navItems.map((item) => {
          // FIXED — was an exact match (currentPath === item.path),
          // which would leave "Business" un-highlighted on every
          // sub-route (e.g. /business/123/staff, /business/new,
          // /business/123/welcome) since none of those equal
          // "/business" exactly. Sub-routes are still "you're in the
          // Business section" from a nav-highlighting point of view —
          // matched with startsWith so the tab stays lit across the
          // whole feature, not just its exact root path. Same applies
          // to Home/Reward/Me if they ever grow sub-routes later.
          const isActive = currentPath === item.path || currentPath.startsWith(`${item.path}/`);
          return (
            <Link
              key={item.path}
              to={item.path}
              className="flex flex-col items-center justify-center flex-1 py-1.5 cursor-pointer transition-colors relative"
            >
              <div className={`w-9 h-9 rounded-xl flex items-center justify-center transition-all ${
                isActive ? "bg-brand-light" : ""
              }`}>
                <i
                  className={`${isActive ? item.activeIcon : item.icon} text-xl transition-colors`}
                  style={{ color: isActive ? "var(--color-brand)" : "var(--color-nav-inactive)" }}
                />
              </div>
              <span
                className="text-[10px] mt-0.5 transition-colors"
                style={{
                  color:      isActive ? "var(--color-brand)" : "var(--color-nav-inactive)",
                  fontWeight: isActive ? 700 : 500,
                }}
              >
                {item.label}
              </span>
              <span
                className="w-1 h-1 rounded-full mt-0.5 transition-opacity"
                style={{ background: "var(--color-brand)", opacity: isActive ? 1 : 0 }}
              />
            </Link>
          );
        })}
      </div>
    </nav>
  );
}